<template>
  <div>
    <div v-if="!loading">
      <div class="flex flex-wrap">
        <button
          v-for="(year, index) in availableYears"
          :key="index"
          :class="[
            'bg-white p-2 rounded font-medium mt-2 mr-2 w-fit shadow-primary',
            { 'text-content-300': selectedYear !== year },
            { 'text-primary-500': selectedYear === year },
          ]"
          @click="selectYear(year)"
        >
          {{ year }}
        </button>
      </div>

      <div class="flex flex-wrap">
        <button
          v-for="(month, index) in availableMonths"
          :key="index"
          :class="[
            'bg-white p-2 rounded font-medium mt-2 mr-2 w-fit shadow-primary',
            { 'text-content-300': selectedMonth !== month.number },
            { 'text-primary-500': selectedMonth === month.number },
          ]"
          @click="selectMonth(month)"
        >
          {{ month.label }}
        </button>
      </div>

      <div v-if="report" class="flex flex-col">
        <div class="card w-fit mt-2">
          <p>
            Cuota de Publicidad:
            <span class="font-medium">{{
              integerToCurrency(report.advertisement_fee)
            }}</span>
          </p>

          <p>
            Cuota de Mantenimiento:
            <span class="font-medium">{{
              integerToCurrency(report.maintenance_fee)
            }}</span>
          </p>
        </div>

        <div class="flex flex-wrap">
          <div
            v-for="branch in report.branches"
            :key="branch.branch_id"
            class="card w-fit mr-4 mt-2"
          >
            <h2>{{ branch.branch_name }}</h2>
            <p>
              Planes (bruto):
              <span class="font-medium">{{
                integerToCurrency(branch.gross_amount)
              }}</span>
            </p>
            <p v-if="branch.coupon_discount_amount > 0" class="text-error-500">
              Descuento primera compra:
              <span class="font-medium">
                − {{ integerToCurrency(branch.coupon_discount_amount) }}
              </span>
            </p>
            <p v-if="branch.wallet_applied_amount > 0" class="text-error-500">
              Monedero canjeado:
              <span class="font-medium">
                − {{ integerToCurrency(branch.wallet_applied_amount) }}
              </span>
            </p>
            <p>
              Planes (neto cobrado):
              <span class="font-medium">{{
                integerToCurrency(branch.stripe_amount)
              }}</span>
            </p>
            <p>
              Reembolsado (Stripe):
              <span class="font-medium">{{
                integerToCurrency(branch.stripe_refunded_amount)
              }}</span>
            </p>
            <p>
              Ventas Tarjeta / Efectivo:
              <span class="font-medium">{{
                integerToCurrency(branch.incomes_amount)
              }}</span>
            </p>
            <p>
              Total:
              <span class="font-medium">{{
                integerToCurrency(branch.total)
              }}</span>
            </p>
            <p>
              Número de tickets:
              <span class="font-medium">{{ branch.number_of_tickets }}</span>
            </p>
            <p>
              Ticket promedio:
              <span class="font-medium">{{
                integerToCurrency(branch.average_per_ticket)
              }}</span>
            </p>
            <p>
              Clientes nuevos:
              <span class="font-medium">{{ branch.new_clients }}</span>
            </p>
            <p>
              Promedio de clientes nuevos:
              <span class="font-medium">{{ branch.new_clients_average }}%</span>
            </p>
            <p>
              Cancelaciones:
              <span class="font-medium">{{ branch.canceled_quotes }}</span>
            </p>

            <p class="font-medium mt-2">Egresos</p>

            <p
              v-for="expense in branch.expenses_by_category"
              :key="expense.expense_category_id"
            >
              {{ expense.category_name }}:
              <span class="font-medium">{{
                integerToCurrency(expense.total)
              }}</span>
            </p>
          </div>
        </div>
      </div>
    </div>

    <div v-else class="flex w-full h-full items-center">
      <loader-icon class="h-10 w-10 text-primary-500 mx-auto"></loader-icon>
    </div>
  </div>
</template>

<script>
import api from "@/api";
import { formatDatetime } from "@/utils/dateFormatter";
import { integerToCurrency } from "@/utils/currencyFormatter";
export default {
  name: "Monthly Sales",

  data() {
    return {
      report: null,
      loading: false,
      selectedYear: new Date().getFullYear(),
      selectedMonth: new Date().getMonth() + 1,
      months: [
        { number: 1, label: "Enero" },
        { number: 2, label: "Febrero" },
        { number: 3, label: "Marzo" },
        { number: 4, label: "Abril" },
        { number: 5, label: "Mayo" },
        { number: 6, label: "Junio" },
        { number: 7, label: "Julio" },
        { number: 8, label: "Agosto" },
        { number: 9, label: "Septiembre" },
        { number: 10, label: "Octubre" },
        { number: 11, label: "Noviembre" },
        { number: 12, label: "Diciembre" },
      ],
    };
  },

  computed: {
    availableYears() {
      const currentYear = new Date().getFullYear();
      const startingYear = 2020;
      const years = [];

      for (let year = startingYear; year <= currentYear; year++) {
        years.push(year);
      }

      return years;
    },

    availableMonths() {
      const currentYear = new Date().getFullYear();
      const currentMonth = new Date().getMonth() + 1;

      if (this.selectedYear === currentYear) {
        return this.months.filter((month) => month.number <= currentMonth);
      }

      return this.months;
    },
  },

  created() {
    this.loadReport();
  },

  methods: {
    formatDatetime,

    integerToCurrency,

    async loadReport() {
      this.loading = true;

      try {
        this.report = await api.reports.getMonthlyReport([
          { name: "year", value: this.selectedYear },
          {
            name: "month",
            value: this.selectedMonth,
          },
        ]);
      } catch (error) {
        this.$store.dispatch("errorSnack", error?.response?.data?.message);
      }

      this.loading = false;
    },

    selectYear(year) {
      if (year === this.selectedYear) {
        return;
      }

      this.selectedYear = year;
      this.selectedMonth = null;
      this.report = null;
    },

    selectMonth(month) {
      if (this.selectedMonth === month) {
        return;
      }

      this.selectedMonth = month.number;

      this.loadReport();
    },
  },
};
</script>